import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { DevicesDevicesService } from '../../../services/devices-services/devices-devices-services/devices-devices.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from '../../shared-components/spinner/spinner.service';
import { EMPTY, Subscription } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { finalize } from 'rxjs/internal/operators/finalize';
import { tap } from 'rxjs/internal/operators/tap';
import { delay } from 'rxjs/internal/operators/delay';

@Component({
  selector: 'app-device-breadcrumb-card',
  templateUrl: './device-breadcrumb-card.component.html',
  styleUrls: ['./device-breadcrumb-card.component.scss']
})
export class DeviceBreadcrumbCardComponent implements OnInit, OnChanges, OnDestroy {

  @Input() deviceInfo;
  lastConnection;
  newConnection;
  waitingUpdate: boolean;
  requestUpdateDeviceSubscription: Subscription;
  remoteAccessSubscription: Subscription;
  openingRemoteAccess = false;
  private remoteAccessWindow: Window | null = null;

  constructor(private devicesService: DevicesDevicesService,
    private snackbarService: SnackBarService,
    private spinnerService: SpinnerService) { }

  ngOnInit() {
    this.waitingUpdate = false;
  }

  public refreshDeviceInfo() {
      this.requestUpdateDeviceSubscription = this.devicesService.requestUpdateDevice(this.deviceInfo.InternalId).pipe(
        tap(o => this.waitingUpdate = true),
        tap(o => this.spinnerService.show('device-update-spinner')),
        tap(o => this.lastConnection = this.deviceInfo.LastConnection),
        delay(3000),
        tap(o => this.waitingUpdate = false),
        tap(o => this.spinnerService.hide('device-update-spinner')),
        tap(o => this.devicesService.refreshDevice()),
        catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
      ).subscribe();
  }

  public isRemoteAccessConfigured(): boolean {
    return this.deviceInfo && this.deviceInfo.RemoteAccess && this.deviceInfo.RemoteAccess.configured === true;
  }

  public openRemoteAccess() {
    if (!this.isRemoteAccessConfigured() || this.openingRemoteAccess) { return; }

    const remoteWindow = window.open('', '_blank');
    if (!remoteWindow) {
      this.snackbarService.open('devices-page.remote control popup blocked', 'error');
      return;
    }

    remoteWindow.opener = null;
    this.remoteAccessWindow = remoteWindow;
    this.openingRemoteAccess = true;
    this.remoteAccessSubscription = this.devicesService.launchRemoteAccess(this.deviceInfo.InternalId).pipe(
      tap(launchUrl => {
        remoteWindow.location.replace(launchUrl);
        this.remoteAccessWindow = null;
      }),
      catchError(error => {
        remoteWindow.close();
        this.remoteAccessWindow = null;
        const message = error && error.error && error.error.message;
        this.snackbarService.open(message && message !== 'Generic error' ? message : 'devices-page.remote control error', 'error');
        return EMPTY;
      }),
      finalize(() => this.openingRemoteAccess = false)
    ).subscribe();
  }

  ngOnChanges() {
    if (this.deviceInfo) {
      this.newConnection = this.deviceInfo.LastConnection;
      if (this.newConnection <= this.lastConnection) {
        this.snackbarService.open('Por favor, vuelva a actualizar los datos del dispositivo', 'warning');
      }
    }
  }

  ngOnDestroy() {
    if (this.requestUpdateDeviceSubscription) { this.requestUpdateDeviceSubscription.unsubscribe(); }
    if (this.remoteAccessSubscription) { this.remoteAccessSubscription.unsubscribe(); }
    if (this.remoteAccessWindow) { this.remoteAccessWindow.close(); }
  }

}
